export enum TipoNota {

    ANULACION = "Anulación de la operación",
    MODIFICACION_DESCRIPCION = "Corrección por error en la descripción o atención de reclamo respecto de bienes adquiridos o servicios prestados",
    DEVOLUCION_TOTAL = "Devolución total",
    DEVOLUCION_ITEM = "Devolución por ítem",
    TIPO_13 = "Credito tipo 13",
    DESCUENTO_GLOBAL = "Descuento Global",
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/recursos/tipoNota.enum.ts